<div class="overlay bg-secondary border-primary-2">
  <span [style]="textStyle" class="content text-primary">{{ text | translate }}</span>
</div>
